import { translate } from 'vue-gettext'

const { pgettext } = translate

// Table field definitions for edge orders
export const edgeOrdersFields = {
  transactionNumber: {
    key: 'transaction_number',
    label: pgettext('edge-orders.fields', 'Transaction Number'),
    _style: 'width: 12%',
    sortable: true,
    requiresPermission: ['edge.orders.transaction_number']
  },
  createdAt: {
    key: 'created_at',
    label: pgettext('edge-orders.fields', 'Created'),
    _style: 'width: 13%',
    sortable: true,
    requiresPermission: ['edge.orders.created_at']
  },
  cabin: {
    key: 'cabin',
    label: pgettext('edge-orders.fields', 'Cabin'),
    _style: 'width: 10%',
    requiresPermission: ['edge.orders.cabin']
  },
  guest: {
    key: 'guest',
    label: pgettext('edge-orders.fields', 'Guest'),
    _style: 'width: 10%',
    requiresPermission: ['edge.orders.guest']
  },
  picacode: {
    key: 'picacode',
    label: pgettext('edge-orders.fields', 'PicaCode'),
    _style: 'width: 10%',
    requiresPermission: ['edge.orders.picacode']
  },
  status: {
    key: 'status',
    label: pgettext('edge-orders.fields', 'Status'),
    _style: 'width: 12%',
    sortable: true,
    requiresPermission: ['edge.orders.status']
  },
  paymentPlatform: {
    key: 'payment_platform',
    label: pgettext('edge-orders.fields', 'Payment Platform'),
    _style: 'width: 12%',
    requiresPermission: ['edge.orders.payment_platform']
  },
  totalAmount: {
    key: 'total_amount',
    label: pgettext('edge-orders.fields', 'Total'),
    _style: 'width: 12%',
    sortable: true,
    filter: false,
    requiresPermission: ['edge.orders.total']
  },
  actions: {
    key: 'actions',
    label: '',
    _style: 'width: 10%',
    sorter: false,
    filter: false
  }
}

// Re-export from shared constant files
export * from '@/domain/core/constant/printJobStatus'